const DateFlexibility = Object.freeze({
  EXACT_DATES: 'exact_dates',
  FLEXIBLE_1_2_DAYS: 'flexible_1_2_days',
  FLEXIBLE_3_5_DAYS: 'flexible_3_5_days',
  FLEXIBLE_BY_A_WEEK: 'flexible_by_a_week',
} as const);

export type DateFlexibility = (typeof DateFlexibility)[keyof typeof DateFlexibility];
export const allDateFlexibility: [DateFlexibility, ...DateFlexibility[]] = Object.values(DateFlexibility) as [DateFlexibility, ...DateFlexibility[]];

export default DateFlexibility;

